module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-left.0411cdf4.svg";